module.exports = __webpack_public_path__ + "static/media/no-balustrade.d5169913.jpg";